import {CUSTOMERS, DELETE_CUSTOMER, GET_CUSTOMER,INVITATION_CUSTOMER, UPDATE_INFO_CUSTOMER,CUSTOMER, DOCUMENT_DOWNLOAD, DOCUMENTS, USER, DOCUMENT, USERS, DOCUMENT_ADD, USER_PERMISSION, USER_GROUP_PERMISSION, DELETE_DOCUMENT, HARD_DELETE} from './Component/EndPointServices';
import { getAppConfiguration } from "../../Config";
import { AuthHeaders } from "./Component/authHeader";
import { interceptFetch } from '../InterceptFetch';
const mlsApiLocal = getAppConfiguration().mlsApiUrl;
class CustomerHelperServices {
    CUSTOMERS = async(accessToken:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "GET",headers: headers};
        try{
        const allCustomer =  await interceptFetch(mlsApiLocal+CUSTOMERS,options).catch(err=>{console.log("the error customer list  ==>",err)});
        return allCustomer;
        }catch(error){console.log(error,"customer error helper")}
    };
    ADD_CUSTOMER = async(param:any, accessToken:string) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "POST",body:JSON.stringify(param),headers: headers,};
        try{
        const addCustomer =  await interceptFetch(mlsApiLocal+CUSTOMER, options).catch(err=>{console.log("the error customer add  ==>",err.message)});
        return addCustomer;
        }catch(error){console.log(error," add customer error helper")}
    };
    GET_CUSTOMER = async(CustomerId:any,accessToken:string) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "GET",headers: headers,};
       try{
        const getCustomer =  await interceptFetch(mlsApiLocal+CUSTOMER+CustomerId, options).catch(err=>{console.log("the error customer add  ==>",err)});
        return getCustomer;
       }catch(error){console.log(error," get customer error helper")}
    };
   DELETE_CUTOMER = async(email:any,accessToken:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "DELETE",headers: headers,};
       try{
        const deleteCustomer =  await interceptFetch(mlsApiLocal+DELETE_CUSTOMER+email, options).catch(err=>{console.log("the error customer add  ==>",err)});
        return deleteCustomer;
       }catch(error){console.log(error," delete customer error helper")}
    }
    SENT_INVITATION_CUSTOMER = async(param:any, accessToken:string)=>{
        const headers = AuthHeaders(accessToken);
        const options = {method: "POST",body:JSON.stringify(param),headers: headers};
       try{
        const sendIvitation =  await interceptFetch(mlsApiLocal+INVITATION_CUSTOMER, options).catch(err=>{console.log("the error customer add  ==>",err)});
        return sendIvitation;
       }catch(error){console.log(error," send invitation customer error helper")}
    }
    UPLOAD_FILE = async(param:any,customerId:any, accessToken:string)=>{
        const bearer = `Bearer ${accessToken}`;
        const headers =  new Headers();
        headers.append("Authorization", bearer);
        const formData = new FormData();
        formData.append('Name',param.Name);
        if(param?.Description){
            formData.append('Description',param.Description);
        }
        formData.append('File',param.File);
        if(param?.DocumentGroupId > 0)
        formData.append('DocumentGroupId',param.DocumentGroupId);
        const options = {method: "POST",body:formData,headers: headers};
       try{ 
        const uploadDocument =  await interceptFetch(mlsApiLocal+CUSTOMER+customerId+DOCUMENT, options).catch(err=>{console.log("the error document upload  ==>",err)});
        return uploadDocument;
       }catch(error){console.log(error," upload document customer error helper")}
    }
    DOCUMENT_UPDATE_FILE = async(param:any,documentId:any, accessToken:string)=>{
        const bearer = `Bearer ${accessToken}`;
        const headers =  new Headers();
        headers.append("Authorization", bearer);
        const formData = new FormData();
        formData.append('Name',param?.Name);
        formData.append('Description',param?.Description);
        formData.append('File',param?.File);
        if(param?.archiveAt){
            formData.append('archiveAt',param?.archiveAt);
        }
        if(param?.DocumentGroupId > 0)
        formData.append('DocumentGroupId',param?.DocumentGroupId);
        const options = {method: "PUT",body:formData,headers: headers};
       try{ 
        const updateDocument =  await interceptFetch(mlsApiLocal+DOCUMENT_ADD+documentId, options).catch(err=>{console.log("the error document upadte  ==>",err)});
        return updateDocument;
       }catch(error){console.log(error," update document customer error helper")}
    }
    ALL_DOCUMENT= async(customerId : number,userId:any, accessToken:string,isArchive:any)=>{
        const headers = AuthHeaders(accessToken);
        const options = {method: "GET",headers: headers};
       try{
        const allDocument =  await interceptFetch(mlsApiLocal+CUSTOMER+customerId+USERS+'/'+userId+DOCUMENTS+`?isArchive=${isArchive}`, options).catch(err=>{console.log("the error All documents  ==>",err)});
        return allDocument;
       }catch(error){console.log(error," all documents error helper")}
    }
    DELETE_DOCUMENT= async(documentId : number, accessToken:string)=>{
        const headers = AuthHeaders(accessToken);
        const options = {method: "DELETE",headers: headers};
       try{
        const deleteDocument =  await interceptFetch(mlsApiLocal+DELETE_DOCUMENT+documentId, options).catch(err=>{console.log("the error delete documents  ==>",err)});
        return deleteDocument;
       }catch(error){console.log(error," delete documents error helper")}
    }
    DOWNLOAD_DOCUMENT= async(documentId:any,accessToken:string)=>{
        const bearer = `Bearer ${accessToken}`;
        const headers =  new Headers();
        headers.append("Authorization", bearer)
        const options = {method: "GET",headers: headers};
       try{
        const allDocument =  await fetch(mlsApiLocal+DOCUMENT_DOWNLOAD+documentId?.id, options).then(async response =>{
            if (response.ok) {
                const blob = await response.blob();
                const downloadUrl = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                let strArr = documentId?.url.split('/');
                let filename = strArr[strArr.length-1];
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                link.remove();
                return blob;
            } else {
                console.error('Failed to download file.');
            }
            return response.json()}).catch(err=>{console.log("the error download file  ==>",err)});
        return allDocument;
       }catch(error){console.log(error," download file error helper")}
    }
    INFO_UPDATE_CUSTOMER=async(param:any,customerId:any, accessToken:string)=>{
        const headers = AuthHeaders(accessToken);
        const options = {method: "PUT",body:JSON.stringify(param),headers: headers};
       try{
        const updateInfoDetail =  await interceptFetch(mlsApiLocal+UPDATE_INFO_CUSTOMER+customerId, options).catch(err=>{console.log("the error customer info update  ==>",err)});
        return updateInfoDetail;
       }catch(error){console.log(error,"info update customer error helper")}
    }
    CHANGE_CUSTOMER_STATUS=async(customerId:any, accessToken:string)=>{
        const headers = AuthHeaders(accessToken);
        const options = {method: "DELETE",headers: headers};
       try{
        const status =  await interceptFetch(mlsApiLocal+CUSTOMER+customerId, options).catch(err=>{console.log("the error customer status  ==>",err)});
        return status;
       }catch(error){console.log(error,"status customer error helper")}
    }
    DELETE_USER_CLIENT=async(customerId:any,userId:any, accessToken:string)=>{
        const headers = AuthHeaders(accessToken);
        const options = {method: "DELETE",headers: headers};
       try{
        const status =  await interceptFetch(mlsApiLocal+CUSTOMER+customerId+'/'+USER+userId, options).catch(err=>{console.log("the client admin customer delete status  ==>",err)});
        return status;
       }catch(error){console.log(error,"status client admin customer delete error helper")}
    }
    USERS_PERMISSIONS=async(endPoint:any,documentId:any, accessToken:string)=>{
        const headers = AuthHeaders(accessToken);
        const options = {method: "GET",headers: headers};
       try{
        const statusPermission =  await interceptFetch(mlsApiLocal+endPoint+documentId+USER_PERMISSION, options).catch(err=>{console.log("the user permissions get status  ==>",err)});
        return statusPermission;
       }catch(error){console.log(error,"status user permissions get error helper")}
    }
    USER_GROUPS_PERMISSIONS=async(endPoint:any,documentId:any, accessToken:string)=>{
        const headers = AuthHeaders(accessToken);
        const options = {method: "GET",headers: headers};
       try{
        const statusGroupPermission =  await interceptFetch(mlsApiLocal+endPoint+documentId+USER_GROUP_PERMISSION, options).catch(err=>{console.log("the user group permissions get status  ==>",err)});
        return statusGroupPermission;
       }catch(error){console.log(error,"status user group permissions get error helper")}
    }
    HARD_DELETE_PERMISSION=async(userId:any, accessToken:string)=>{
        const headers = AuthHeaders(accessToken);
        const options = {method: "DELETE",headers: headers};
       try{
        const hardPermission =  await interceptFetch(mlsApiLocal+USER+userId+HARD_DELETE, options).catch(err=>{console.log("the user group permissions delete user status  ==>",err)});
        return hardPermission;
       }catch(error){console.log(error,"status user group permissions  delete user error helper")}
    }
}
export default new CustomerHelperServices();